module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.b2fc11b3.webp";